
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payments_redirect",
      function () {
        return require("private-next-pages/payments_redirect.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payments_redirect"])
      });
    }
  